/* =====================================================================
   Great Lakes Lavender Farm - Reading Comfort layer (v2)
   1. Raises text that is smaller than a comfortable minimum (it never
      shrinks anything and never changes markup, text or behaviour; it
      only adds a class + data attributes that gllf-comfort.css reads).
   2. Adds a "Text size" choice (Standard / Large / Largest) to the desktop
      menu bar and to the bottom of the mobile menu drawer. The choice is
      remembered on this device.
   v2: the mobile control lives INSIDE the drawer (it was landing in the
   header bar next to the menu button) and is a compact segmented control.
   Skips: floating/fixed widgets, the header icon row, the simulator and
   wholesale hub pages (window.GLLFComfort.off), anything inside
   [data-gllf-comfort-skip].
   ===================================================================== */
(function () {
  'use strict';
  if (window.__gllfComfort) return;
  window.__gllfComfort = true;

  var d = document, html = d.documentElement;
  var cfg = window.GLLFComfort || {};
  var KEY = 'gllf_text_size_v1';
  var FLOORS = [
    { p: 16, u: 15, c: 14, i: 16 },
    { p: 18, u: 17, c: 15, i: 18 },
    { p: 20, u: 19, c: 16, i: 20 }
  ];
  var LABELS = ['Standard', 'Large', 'Largest'];

  if (cfg.off) { html.classList.add('gllf-cf-off'); return; }

  function readLevel() {
    try { var v = parseInt(localStorage.getItem(KEY), 10); return v >= 0 && v <= 2 ? v : 0; } catch (e) { return 0; }
  }
  var level = readLevel();
  html.setAttribute('data-gllf-ts', String(level));

  /* ---------------- 1. Minimum text sizes ---------------- */
  var PROSE = { P: 1, LI: 1, DD: 1, DT: 1, TD: 1, TH: 1, BLOCKQUOTE: 1, FIGCAPTION: 1, LABEL: 1, CAPTION: 1, ADDRESS: 1, LEGEND: 1 };
  var SKIP = '[data-gllf-comfort-skip],svg,canvas,script,style,noscript,template,sup,sub,option,.visually-hidden,.gllf-sr-only,.gllf-header-count,.cart-count-bubble,.gllf-ts,[aria-hidden="true"]';
  var INPUTS = 'input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="hidden"]):not([type="color"]):not([type="file"]):not([type="submit"]):not([type="button"]),select,textarea';
  var fixedMemo = new WeakMap();

  function roots() {
    var r = [];
    var main = d.getElementById('MainContent');
    if (main) r.push(main);
    d.querySelectorAll('.shopify-section-group-footer-group').forEach(function (s) { r.push(s); });
    return r;
  }
  function inFixed(el) {
    var chain = [], x = el, res = false;
    while (x && x !== d.body && x !== html) {
      if (fixedMemo.has(x)) { res = fixedMemo.get(x); break; }
      chain.push(x);
      var pos = getComputedStyle(x).position;
      if (pos === 'fixed') { res = true; break; }
      x = x.parentElement;
    }
    chain.forEach(function (c) { fixedMemo.set(c, res); });
    return res;
  }
  function ownText(el) {
    var t = '';
    for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3) t += n.nodeValue;
    return t.replace(/\s+/g, ' ').trim();
  }
  function depth(el) { var n = 0; while (el) { n++; el = el.parentElement; } return n; }
  function kindOf(el, cs, text) {
    if (cs.textTransform === 'uppercase' || (text.length > 3 && text === text.toUpperCase() && /[A-Z]{3}/.test(text) && parseFloat(cs.letterSpacing) > 0.5)) return 'c';
    if (PROSE[el.tagName] || text.length >= 40 || el.closest('p,li,td,dd,blockquote')) return 'p';
    return 'u';
  }
  function tag(el, kind, size) {
    el.classList.add('gllf-tsz');
    el.setAttribute('data-cf', kind);
    el.setAttribute('data-cf-o', String(size));
  }
  function untagAll() {
    d.querySelectorAll('.gllf-tsz').forEach(function (el) {
      el.classList.remove('gllf-tsz'); el.removeAttribute('data-cf'); el.removeAttribute('data-cf-o');
    });
  }
  function collect(root, out) {
    if (!root || root.nodeType !== 1) return;
    if (root.closest && root.closest(SKIP)) return;
    var w = d.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var seen = new Set();
    while (w.nextNode()) {
      var n = w.currentNode, el = n.parentElement;
      if (!el || seen.has(el) || n.nodeValue.trim().length < 2) continue;
      seen.add(el);
      out.push(el);
    }
    if (root.matches && root.matches(INPUTS)) out.push(root);
    if (root.querySelectorAll) root.querySelectorAll(INPUTS).forEach(function (i) { out.push(i); });
  }
  function apply(list) {
    var f = FLOORS[level];
    list = list.filter(function (el) { return el.isConnected && !el.classList.contains('gllf-tsz'); });
    list.sort(function (a, b) { return depth(a) - depth(b); }); // parents first, children then inherit
    list.forEach(function (el) {
      if (el.closest(SKIP) || inFixed(el)) return;
      var cs = getComputedStyle(el);
      var size = parseFloat(cs.fontSize);
      if (!size) return;
      var isInput = el.matches(INPUTS);
      if (isInput) { if (size < f.i - 0.1) tag(el, 'i', size); return; }
      var text = ownText(el);
      if (text.length < 3) return; // counts, icons, arrows
      var kind = kindOf(el, cs, text);
      if (size < f[kind] - 0.1) tag(el, kind, size);
    });
  }
  function scanAll() {
    var list = [];
    roots().forEach(function (r) { collect(r, list); });
    apply(list);
  }

  /* Watch for content that apps and tools add later (throttled). */
  var pending = [], timer = null;
  function flush() {
    timer = null;
    var nodes = pending; pending = [];
    var list = [];
    nodes.forEach(function (n) { collect(n, list); });
    if (list.length) apply(list);
  }
  function watch() {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 3) n = n.parentElement;
          if (n && n.nodeType === 1 && !(n.classList && n.classList.contains('gllf-ts'))) pending.push(n);
        }
      }
      if (pending.length && !timer) timer = setTimeout(flush, 400);
    });
    roots().forEach(function (r) { mo.observe(r, { childList: true, subtree: true }); });
  }

  /* ---------------- 2. Text size choice ---------------- */
  var live;
  function announce(msg) {
    if (!live) {
      live = d.createElement('div'); live.className = 'gllf-sr-only'; live.setAttribute('aria-live', 'polite');
      d.body.appendChild(live);
    }
    live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30);
  }
  function setLevel(v) {
    v = Math.max(0, Math.min(2, v | 0));
    level = v;
    try { localStorage.setItem(KEY, String(v)); } catch (e) {}
    html.setAttribute('data-gllf-ts', String(v));
    untagAll();
    scanAll();
    d.querySelectorAll('.gllf-ts__opt').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-ts') === v)); });
    d.querySelectorAll('.gllf-ts__now').forEach(function (s) { s.textContent = LABELS[v]; });
    announce('Text size set to ' + LABELS[v]);
    d.dispatchEvent(new CustomEvent('gllf:textsize', { detail: { level: v } }));
  }
  var uid = 0;

  /* Desktop: pill button in the menu bar that opens a small popover. */
  function control() {
    var id = 'GLLFTextSize' + (++uid);
    var el = d.createElement('li');
    el.className = 'gllf-ts';
    el.innerHTML =
      '<button type="button" class="gllf-ts__btn" aria-expanded="false" aria-controls="' + id + '">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 19 8 5h1l5 14M4.8 14h7.4M14 19l3.5-9h.8l3.7 9M15 16.5h5.6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        'Text size<span class="gllf-sr-only">: <span class="gllf-ts__now">' + LABELS[level] + '</span></span>' +
      '</button>' +
      '<div class="gllf-ts__pop" id="' + id + '" role="group" aria-label="Text size" hidden>' +
        '<p class="gllf-ts__title">Text size</p>' +
        '<p class="gllf-ts__hint">Make the words on every page bigger. We\'ll remember your choice on this device.</p>' +
        '<div class="gllf-ts__opts">' +
          [0, 1, 2].map(function (v) {
            return '<button type="button" class="gllf-ts__opt" data-ts="' + v + '" aria-pressed="' + (v === level) + '"><span aria-hidden="true">A</span><small>' + LABELS[v] + '</small></button>';
          }).join('') +
        '</div>' +
        '<p class="gllf-ts__tip">Want everything bigger, pictures too? Hold <kbd>Ctrl</kbd> (<kbd>⌘</kbd> on a Mac) and press <kbd>+</kbd>.</p>' +
      '</div>';
    var btn = el.querySelector('.gllf-ts__btn'), pop = el.querySelector('.gllf-ts__pop');
    function close() { pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = pop.hidden; pop.hidden = !open; btn.setAttribute('aria-expanded', String(open));
      if (open) { var cur = pop.querySelector('[aria-pressed="true"]'); if (cur) cur.focus(); }
    });
    el.addEventListener('click', function (e) {
      var o = e.target.closest('.gllf-ts__opt');
      if (o) { e.stopPropagation(); setLevel(+o.getAttribute('data-ts')); }
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) { close(); btn.focus(); } });
    d.addEventListener('click', function (e) { if (!el.contains(e.target)) close(); });
    return el;
  }

  /* Mobile drawer: one compact row - label, current size, 3-way segmented control. */
  function drawerControl() {
    var id = 'GLLFTextSizeM' + (++uid);
    var el = d.createElement('div');
    el.className = 'gllf-ts gllf-ts--drawer';
    el.setAttribute('role', 'group');
    el.setAttribute('aria-labelledby', id);
    el.innerHTML =
      '<div class="gllf-ts__row">' +
        '<span class="gllf-ts__label" id="' + id + '">Text size</span>' +
        '<span class="gllf-ts__now" aria-hidden="true">' + LABELS[level] + '</span>' +
      '</div>' +
      '<div class="gllf-ts__seg">' +
        [0, 1, 2].map(function (v) {
          return '<button type="button" class="gllf-ts__opt" data-ts="' + v + '" aria-pressed="' + (v === level) + '" aria-label="' + LABELS[v] + ' text"><span aria-hidden="true">A</span></button>';
        }).join('') +
      '</div>';
    el.addEventListener('click', function (e) {
      var o = e.target.closest('.gllf-ts__opt');
      if (o) { e.preventDefault(); e.stopPropagation(); setLevel(+o.getAttribute('data-ts')); }
    });
    return el;
  }

  function mountControls() {
    var desk = d.querySelector('ul.gllf-mega-desktop__list');
    if (desk && !desk.querySelector('.gllf-ts')) desk.appendChild(control());

    // Remove any copy that ended up outside a menu drawer (v1 put it in the header bar).
    d.querySelectorAll('.gllf-ts--drawer').forEach(function (x) {
      if (!x.closest('.gllf-mega-mobile__drawer, #menu-drawer')) x.remove();
    });

    var screen = d.querySelector('.gllf-mega-mobile__drawer [data-gllf-mobile-screen="menu"]');
    if (screen) {
      if (!screen.querySelector('.gllf-ts')) screen.appendChild(drawerControl());
      return;
    }
    var veena = d.querySelector('#menu-drawer .menu-drawer__navigation-container, #menu-drawer .menu-drawer__navigation');
    if (veena && !veena.querySelector('.gllf-ts')) veena.appendChild(drawerControl());
  }

  window.GLLFComfort = Object.assign(cfg, { setTextSize: setLevel, rescan: function () { untagAll(); scanAll(); } });

  function start() {
    scanAll();
    watch();
    mountControls();
    // Menus and apps that render late
    setTimeout(function () { mountControls(); }, 1500);
    window.addEventListener('load', function () { scanAll(); mountControls(); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
